import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { PushNotificationsDisabledModalPage } from './push-notifications-disabled-modal.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild()],
  declarations: [PushNotificationsDisabledModalPage],
})
export class PushNotificationsDisabledModalPageModule {}
